import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "base-line" }
const _hoisted_2 = { class: "home-slider" }
const _hoisted_3 = { class: "home-catalog" }

import BaseLine from '@/components/Lines/BaseLine.vue'
import HomeSlider from '@/components/Sliders/HomeSlider.vue'
import HomeCatalog from '@/components/Catalogs/HomeCatalog.vue'
import CreateAccount from '@/components/Register/CreateAccount.vue'
import CreateAccount2 from '@/components/Register/CreateAccount2.vue'
import HomeSliderLoader from '@/components/Loaders/HomeSliderLoader.vue'
import HomeCatalogLoader from '@/components/Loaders/HomeCatalogLoader.vue'
import { computed, onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useCatalogStore } from '@/stores/catalog'


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {


const authStore = useAuthStore()
const isAuth = computed(() => authStore.isAuth)
const catalog = useCatalogStore()
const catalogItems = computed(() => catalog.items)
const catalogLoaded = computed(() => catalog.isLoaded)

onMounted(() => {
  catalog.fetchCatalogAsync()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(BaseLine, { text: "твое личное время" })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (!catalogLoaded.value)
            ? (_openBlock(), _createBlock(HomeSliderLoader, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (catalogLoaded.value)
        ? (_openBlock(), _createBlock(HomeSlider, {
            key: 0,
            catalog: catalogItems.value
          }, null, 8, ["catalog"]))
        : _createCommentVNode("", true)
    ]),
    (!isAuth.value)
      ? (_openBlock(), _createBlock(CreateAccount, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (!catalogLoaded.value)
            ? (_openBlock(), _createBlock(HomeCatalogLoader, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (catalogLoaded.value)
        ? (_openBlock(), _createBlock(HomeCatalog, {
            key: 0,
            catalog: catalogItems.value
          }, null, 8, ["catalog"]))
        : _createCommentVNode("", true)
    ]),
    (!isAuth.value)
      ? (_openBlock(), _createBlock(CreateAccount2, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})